/* global removeTrapFocus, theme */

if (!customElements.get('main-search')) {
  const MainSearch = class extends HTMLElement {
    constructor() {
      super();

      this.querySelectorAll('.main-search__close').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          document.body.classList.remove('show-search');
          removeTrapFocus(theme.trapOpener);
        });
      });

      const input = this.querySelector('.main-search__input');
      input?.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') this.querySelector('.main-search__close')?.click();
      });
      input?.addEventListener('keydown', this.handleKeyDown.bind(this));
      // Suggestions are replaced wholesale on every keystroke, so the roving pointer has to
      // drop with them rather than stay aimed at an option that no longer exists.
      input?.addEventListener('input', () => this.clearActiveResult());

      this.activeResultIndex = -1;
    }

    get resultOptions() {
      return [...this.querySelectorAll('.main-search__results [role="option"]')];
    }

    clearActiveResult() {
      this.activeResultIndex = -1;
      this.resultOptions.forEach((option) => {
        option.classList.remove('search-result-active');
        option.setAttribute('aria-selected', 'false');
      });
      this.querySelector('.main-search__input')?.setAttribute('aria-activedescendant', '');
    }

    handleKeyDown(event) {
      const options = this.resultOptions;
      if (options.length === 0) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.activeResultIndex = Math.min(this.activeResultIndex + 1, options.length - 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.activeResultIndex = Math.max(this.activeResultIndex - 1, 0);
      } else if (event.key === 'Enter' && this.activeResultIndex >= 0) {
        event.preventDefault();
        options[this.activeResultIndex].querySelector('a')?.click();
        return;
      } else {
        return;
      }

      options.forEach((option, index) => {
        const active = index === this.activeResultIndex;
        option.classList.toggle('search-result-active', active);
        option.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      const active = options[this.activeResultIndex];
      event.currentTarget.setAttribute('aria-activedescendant', active.id);
      active.scrollIntoView({ block: 'nearest' });
    }
  };

  window.customElements.define('main-search', MainSearch);
}
